import { Component, Input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { MatMenuItem } from '@angular/material/menu';
import { MatIconButton } from '@angular/material/button';
import { MatTooltip } from '@angular/material/tooltip';

@Component({
  selector: 'app-tags-button',
  templateUrl: './tags-button.component.html',
  styleUrls: ['./tags-button.component.scss'],
  imports: [TranslateModule, MatMenuItem, MatIconButton, MatTooltip],
})
export class TagsButtonComponent {
  @Input() isMenu = false;
  @Input() label: string;

  constructor() {}
}
